module.exports = __webpack_public_path__ + "static/media/elevated2-mobile.c7ab45a9.jpg";